module.exports = __webpack_public_path__ + "img/error-img.8f0094e8.png";